import { Style } from "@dicebear/core"
import voxelArtDefinition from "@dicebear/styles/voxel-art.json"

export const AVATAR_STYLE = new Style(voxelArtDefinition)

export const AVATAR_OPTIONS = {
  skinColor: [
    "#f5d0b0",
    "#eab890",
    "#dda878",
    "#b07347",
    "#7d4a26"
  ]
}
